import styled from 'styled-components'

type WrapperProps = {
    $hidden?: boolean
}
export const Wrapper = styled.div<WrapperProps>`
    display: ${({ $hidden }) => $hidden ? 'none' : ''};
    margin-top: 5px;
    select {
        font-size: 1em;
        height: auto;
    }
`

export const Div = styled.div`
    text-align: right;
    margin-top: 5px;
`